import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps, styled } from "@mui/material";

const StyledAvatar = styled(MuiAvatar)(() => {
  return {};
});

interface AvatarProps extends MuiAvatarProps {
  children: React.ReactNode;
}

export const Avatar: React.FC<AvatarProps> = ({ children, ...props }) => {
  return <StyledAvatar {...props}> {children}</StyledAvatar>;
};

export default Avatar;
